/* CURNIS — ponte moduli → gestionale (via App Proxy Shopify)
 *
 * Come funziona:
 *  1. intercetta l'invio dei moduli richiesta (quelli con "Tipo modulo"/"Tipo richiesta")
 *  2. manda i campi in JSON all'App Proxy (stesso dominio → nessun CORS, richiesta firmata da Shopify)
 *  3. SUBITO DOPO lascia partire il modulo nativo Shopify → l'email arriva sempre (rete di sicurezza)
 *
 * Se l'invio al gestionale fallisce, la richiesta viene messa in coda nel browser
 * e ritentata al caricamento successivo. Nessun dato sensibile viene registrato in console.
 *
 * FOTOGRAFIE — riscritte il 17 settembre 2026, e il cambio e' importante
 *  Un modulo puo' avere un campo <input type="file">. Le immagini vengono
 *  rimpicciolite QUI nel browser (1600 px, qualita' 0,72) e poi mandate DENTRO
 *  LA STESSA RICHIESTA del modulo, in base64.
 *
 *  Prima era il contrario: il server rispondeva con dei recapiti monouso e i
 *  byte partivano in una SECONDA richiesta, in binario. Il ragionamento scritto
 *  qui era che base64 pesa un terzo in piu' e «farebbe sforare i limiti del
 *  Worker». Non era vero, e non era stato misurato: provato contro l'App Proxy
 *  vero, 50 MB passano. Il vero limite era un altro, e non era il peso.
 *
 *  Il vero limite: fra la prima richiesta e la seconda c'e' una finestra in cui
 *  la pagina puo' andarsene — e quando se ne va, le richieste in volo muoiono.
 *  Se ne andava sempre, perche' lo script hCaptcha di Shopify fa partire il
 *  modulo da se'. Le fotografie non arrivavano MAI. Togliendo la seconda
 *  richiesta, la finestra non esiste piu': se parte il modulo, partono anche
 *  le fotografie, perche' sono la stessa cosa.
 */
(function () {
  var CFG = window.CURNIS_FORMS || {};
  var ENDPOINT = CFG.endpoint;
  if (!ENDPOINT) return;

  var QUEUE_KEY = "curnis_forms_queue";
  var TIMEOUT_MS = 4000;
  var MAX_FIELD = 5000; // taglio di sicurezza per campo

  /* ——— fotografie ——— */
  var FOTO_MAX = 6;             // quante ne accettiamo per richiesta
  /* 1600 px e qualita' 0,72 — misurato il 17 settembre 2026 su una fotografia
     vera di orologio: 506 KB, che codificati per il viaggio diventano 675 KB.
     Cinque stanno in 3,3 MB. Prima erano 2000 px e 0,78 (905 KB l'una, 5,9 MB
     in cinque): si e' sceso perche' adesso le fotografie viaggiano DENTRO la
     richiesta del modulo, e quella richiesta deve partire in fretta anche da
     un telefono in centro a Bergamo. A 1600 px un quadrante si legge, un
     graffio si vede, il numero di serie si legge: e' tutto quello che serve
     per una valutazione. */
  var FOTO_LATO = 1600;         // lato lungo massimo, in pixel
  var FOTO_QUALITA = 0.72;
  /* IL PESO DEL FILE SCELTO NON DEVE QUASI MAI DIRE DI NO.
     Era 8 MB, e un telefono da 48 megapixel li supera senza sforzo: il cliente
     si vedeva scartare una fotografia perfetta senza capire perche'. Adesso il
     tetto e' 40 MB, cioe' oltre qualunque scatto di telefono o reflex. Non e'
     zero perche' serve fermare il caso in cui qualcuno sceglie per sbaglio un
     file enorme che non e' una fotografia — aprirlo bloccherebbe il telefono. */
  var FOTO_PESO_MAX = 40 * 1024 * 1024;  // scarto prima ancora di aprirlo
  /* Tetto complessivo del corpo, codificato. Misurato contro l'App Proxy vero
     il 17 settembre 2026, mandandogli corpi veri di dimensione crescente:
     3 MB passano in 2 secondi, 10 MB in 6, 30 MB in 18, 50 MB in 30 — e quei
     tempi sono la mia linea in salita, non un limite di Shopify. Quindi il
     tetto qui non difende il proxy: difende la pazienza di chi aspetta.
     Trenta non si raggiungono mai con sei fotografie ricodificate (4 MB) —
     servono solo per il caso raro in cui una non si lascia ricodificare e
     parte com'e'. */
  var FOTO_BUDGET = 30 * 1024 * 1024;
  /* Quanto si aspetta un invio CON fotografie. Sei fotografie ricodificate
     fanno circa 4 MB: su una rete in salita lenta ci mettono il loro tempo, e
     interrompere vorrebbe dire perderle. Due minuti sono tanti da guardare, ma
     chi sta caricando legge «Invio le fotografie...» e sa che sta succedendo;
     e se la rete muore davvero, il testo della richiesta viene messo in coda e
     riparte da solo alla pagina dopo. */
  var TIMEOUT_FOTO = 120000;

  function readQueue() {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch (e) { return []; }
  }
  function writeQueue(q) {
    try { localStorage.setItem(QUEUE_KEY, JSON.stringify(q.slice(-20))); } catch (e) {}
  }

  function post(payload, attesa) {
    var ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, attesa || TIMEOUT_MS) : null;
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "same-origin",
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      if (!r.ok) throw new Error("http_" + r.status);
      /* Il corpo dice quante fotografie sono state salvate davvero. Se non e'
         JSON valido non e' un errore: il modulo e' comunque arrivato. */
      return r.json().catch(function () { return {}; });
    }).catch(function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    });
  }

  /* ————————————————————————— fotografie —————————————————————————
     Rimpicciolisce nel browser: 2000 px di lato lungo bastano a valutare un
     orologio e fanno partire l'invio in un attimo anche da telefono.
     createImageBitmap regge anche l'HEIC degli iPhone dove il sistema lo sa
     decodificare; dove non ce la fa si ripiega sull'originale, che e' meglio di
     una foto persa. */
  function decodifica(file) {
    if (typeof createImageBitmap === "function") {
      return createImageBitmap(file).catch(function () { return viaTagImg(file); });
    }
    return viaTagImg(file);
  }
  function viaTagImg(file) {
    return new Promise(function (ok, no) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); ok(img); };
      img.onerror = function () { URL.revokeObjectURL(url); no(new Error("non decodificabile")); };
      img.src = url;
    });
  }

  /* PREPARARE PRESTO, NON AL MOMENTO DELL'INVIO.
     ═════════════════════════════════════════════
     Misurato il 17 settembre 2026: sei scatti da 1,8 MB ci mettono 2,4 secondi
     a essere ricodificati su un computer da scrivania, e da tre a otto volte
     tanto su un telefono. Prima tutto quel lavoro cominciava quando l'utente
     premeva «Invia richiesta»: il modulo restava fermo dieci, quindici secondi
     senza dire niente, e sembrava che il pulsante non funzionasse.

     Adesso ogni fotografia comincia a prepararsi appena viene scelta. Mentre
     l'utente scrive nome, email e telefono — che sono secondi buoni — il
     lavoro e' gia' in corso, e quando preme invia di solito e' finito.

     La cache serve a non rifarlo due volte: la chiave e' il File stesso, e una
     WeakMap lo lascia sparire dalla memoria appena l'utente toglie la
     fotografia dall'elenco. Con una Map normale resterebbero in memoria tutte
     le immagini scartate, che e' proprio quello che un telefono non ha. */
  var giaPronte = new (typeof WeakMap !== "undefined" ? WeakMap : Object)();

  function rimpicciolisci(file) {
    if (giaPronte.get) {
      var gia = giaPronte.get(file);
      if (gia) return gia;
    }
    var lavoro = ricodifica(file);
    if (giaPronte.set) giaPronte.set(file, lavoro);
    return lavoro;
  }

  function ricodifica(file) {
    return decodifica(file).then(function (src) {
      var w = src.width || src.naturalWidth, h = src.height || src.naturalHeight;
      if (!w || !h) throw new Error("dimensioni sconosciute");
      var s = Math.min(1, FOTO_LATO / Math.max(w, h));
      var cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
      var c = document.createElement("canvas");
      c.width = cw; c.height = ch;
      var ctx = c.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(src, 0, 0, cw, ch);
      if (src.close) src.close();
      return new Promise(function (ok) {
        /* SE LA RI-CODIFICA NON RIESCE, PARTE L'ORIGINALE.
           Deciso cosi' dal cliente (15 set 2026): «non mi interessa formattare
           la foto, mi interessa che sia super compatibile e non si blocchi
           mai». La regola qui e' quella: una fotografia non si perde mai.

           Il ridimensionamento resta la strada normale — fa partire l'invio in
           un attimo anche da telefono, e ridisegnando l'immagine su una tela
           nuova butta via i metadati, comprese le coordinate GPS di dove e'
           stata scattata. Quando non riesce (formati che il browser non sa
           decodificare, memoria finita, tele troppo grandi su telefoni vecchi)
           si manda il file com'e': arriva piu' pesante e con i suoi metadati
           dentro, ma ARRIVA.
           Se un domani si vuole togliere il GPS anche in quel caso, il posto
           giusto e' il Worker: si ripuliscono i byte all'arrivo, senza toccare
           niente qui e senza rischiare di bloccare l'invio. */
        c.toBlob(function (b) { ok(b || file); }, "image/jpeg", FOTO_QUALITA);
      });
    }).catch(function () {
      return file;                      /* mai perdere una fotografia */
    });
  }

  /* IL FERMO — TRATTENERE UN MODULO CHE QUALCUN ALTRO VUOLE FAR PARTIRE
     ═══════════════════════════════════════════════════════════════════
     Scoperto il 17 settembre 2026 leggendo la traccia di chi chiamava:

       +29443ms  prototype.submit()
                 at .../storefront-forms-hcaptcha/ce_storefront_forms_captcha_hcaptcha.v1.5.3.iife.js
       +29444ms  la pagina se ne va
       +30125ms  PUT foto 1 e 2
       +30472ms  falliti tutti e due

     E' lo script hCaptcha DI SHOPIFY, non un'app: quando la verifica e'
     attiva, e' lui a far partire il modulo. Non c'e' niente da disattivare.

     PERCHE' IL PRIMO TENTATIVO NON BASTAVA. Avevamo sostituito form.submit
     sull'OGGETTO modulo. Ma un metodo si puo' chiamare anche dal PROTOTIPO, e
     in quel caso la sostituzione sull'oggetto non si vede nemmeno. E' quello
     che fa lo script di Shopify, ed e' un dettaglio che dal codice non si
     indovina: si e' visto solo mettendo una traccia su chi chiamava.

     Percio' il fermo sta sul prototipo. Ma e' CHIRURGICO, e deve restarlo:
     trattiene solo i moduli che stiamo davvero caricando in quel momento, e
     lascia passare tutto il resto — compresi i moduli che il pixel di Facebook
     fa partire dentro i suoi iframe, che nella stessa traccia comparivano
     quattro volte ed erano innocui. Una sostituzione larga li romperebbe.

     SI INSTALLA SUBITO, ALL'APERTURA DELLA PAGINA — e questa riga e' tutta la
     correzione del 17 settembre 2026 (sera). Prima si installava al PRIMO
     invio, e per hCaptcha era come se non ci fosse. Ecco la traccia che lo
     dimostra, presa dal negozio vero:

       +91196ms  evento submit sul modulo
       +91198ms  cn:foto-preparo (2)
       +91827ms  prototype.submit()  DA: ...hcaptcha.v1.5.3.iife.js   ← senza fermo
       +92587ms  la richiesta con le fotografie parte
       +93000ms  prototype.submit()  DA: forms-bridge.js              ← col fermo

     Nella prima chiamata il fermo non compare nella pila; nella seconda si'.
     Vuol dire che esistono DUE riferimenti alla stessa funzione: hCaptcha si
     fotografa HTMLFormElement.prototype.submit quando si carica, e poi chiama
     quella fotografia. Se il fermo arriva dopo, nella sua fotografia non c'e'.

     Installandolo all'apertura della pagina, la fotografia che hCaptcha prende
     e' gia' quella col fermo dentro. Non e' una gara vinta per un soffio: il
     ponte parte con la pagina, hCaptcha lo carica Shopify piu' tardi e solo
     quando serve.

     Resta CHIRURGICO come prima: trattiene solo i moduli che stiamo davvero
     caricando in quel momento, e lascia passare tutto il resto — compresi i
     moduli che il pixel di Facebook fa partire dentro i suoi iframe.
     Si installa una volta sola per pagina, anche con cinque moduli. */
  var inAttesa = new (typeof WeakSet !== "undefined" ? WeakSet : Object)();
  var fermoMesso = false;

  /* LA PAGINA SE NE STA ANDANDO?
     Serve a non creare richieste doppie. Quando il browser lascia la pagina,
     le richieste in volo falliscono — ma il server puo' averle gia' ricevute e
     lavorate per intero (il Worker le porta a termine con waitUntil). Se in
     quel caso rimettessimo il testo in coda, alla pagina dopo partirebbe di
     nuovo e nel gestionale arriverebbero DUE schede per un invio solo.
     E' successo: il 17 settembre 2026 una prova ne ha prodotte due, una con le
     fotografie vuote e una senza campo foto affatto — quella era la coda. */
  var paginaSeNeVa = false;
  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("pagehide", function () { paginaSeNeVa = true; });
    window.addEventListener("beforeunload", function () { paginaSeNeVa = true; });
  }
  function installaFermo() {
    if (fermoMesso || typeof HTMLFormElement === "undefined") return;
    fermoMesso = true;
    var proto = HTMLFormElement.prototype;
    ["submit", "requestSubmit"].forEach(function (nome) {
      var vero = proto[nome];
      if (typeof vero !== "function") return;
      proto[nome] = function () {
        if (inAttesa.has && inAttesa.has(this)) return;   /* trattenuto: parte dopo */
        return vero.apply(this, arguments);
      };
    });
  }

  /* I BYTE DENTRO IL TESTO.
     Una richiesta JSON non sa portare byte grezzi, quindi le fotografie si
     scrivono in base64 — un alfabeto di sole lettere e numeri. Costa un terzo
     di peso in piu' (506 KB diventano 675), ed e' il prezzo per farle viaggiare
     nella STESSA richiesta del modulo invece che in una seconda: vedi il
     commento lungo in fondo a questo file.

     Non solleva mai. Se il lettore fallisce restituisce stringa vuota e chi
     chiama scarta QUELLA fotografia — le altre e il testo partono comunque. */
  function inBase64(blob) {
    return new Promise(function (ok) {
      try {
        var fr = new FileReader();
        fr.onload = function () {
          var s = String(fr.result || "");
          var virgola = s.indexOf(",");            /* «data:image/jpeg;base64,» */
          ok(virgola > -1 ? s.slice(virgola + 1) : "");
        };
        fr.onerror = function () { ok(""); };
        fr.onabort = function () { ok(""); };
        fr.readAsDataURL(blob);
      } catch (e) { ok(""); }
    });
  }

  /* ritenta le richieste rimaste in coda (invii precedenti falliti).

     UNA ALLA VOLTA, E SI TOGLIE SOLO QUANDO E' ARRIVATA.

     Prima qui si leggeva la coda, la si azzerava SUBITO e poi si mandavano
     tutte insieme, rimettendo dentro quelle fallite. Due guai.
     Il primo: fra l'azzeramento e la risposta c'e' una finestra in cui la coda
     e' vuota su disco ma le richieste non sono ancora arrivate da nessuna
     parte. Se l'utente chiude la scheda li' in mezzo — ed e' il momento in cui
     e' piu' probabile che lo faccia, perche' e' appena entrato in una pagina —
     quelle richieste non esistono piu'.
     Il secondo: mandarle tutte insieme significa che un Worker lento le vede
     arrivare in blocco, e il suo limite per indirizzo IP (10 al minuto) puo'
     scartare le ultime.

     Adesso si manda la prima, e solo quando ha risposto la si toglie dalla
     coda e si passa alla seconda. Se una fallisce ci si ferma: resta lei e
     restano tutte quelle dopo, e si ritenta alla prossima pagina aperta.
     Nel peggiore dei casi una richiesta arriva due volte (se la risposta si
     perde dopo che il Worker ha salvato): un doppione si vede e si cancella,
     una richiesta persa no. */
  function flushQueue() {
    if (!readQueue().length) return;
    (function prossima() {
      var q = readQueue();
      if (!q.length) return;
      var item = q[0];
      post(item).then(function () {
        /* si toglie la PRIMA, non "quella": readQueue rilegge da localStorage
           e restituisce oggetti nuovi ogni volta, quindi un confronto per
           identita' sarebbe sempre falso. La coda si consuma in ordine. */
        var cur = readQueue();
        cur.shift();
        writeQueue(cur);
        prossima();
      }).catch(function () {
        /* si ferma qui: la coda resta com'e' e si ritenta piu' tardi */
      });
    })();
  }

  function collect(form, meta) {
    var data = {};
    var els = form.querySelectorAll("input[name], textarea[name], select[name]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var name = el.name || "";
      var m = name.match(/^contact\[(.+)\]$/);
      if (!m) continue;                                  // solo i campi del modulo
      if (el.type === "checkbox" && !el.checked) continue;
      if (el.type === "radio" && !el.checked) continue;
      var key = m[1];
      var val = String(el.value == null ? "" : el.value).slice(0, MAX_FIELD);
      if (data[key]) data[key] += ", " + val; else data[key] = val;
    }
    return { campi: data, meta: meta };
  }

  function bridge(form) {
    var typeField = form.querySelector('[name="contact[Tipo modulo]"], [name="contact[Tipo richiesta]"]');
    if (!typeField) return;                               // solo i moduli richiesta
    if (moduloDiVerifica(form)) return;                   // non il modulo della verifica: vedi init()
    var openedAt = Date.now();

    /* honeypot: invisibile all'utente, i bot lo compilano */
    var hp = document.createElement("input");
    hp.type = "text"; hp.name = "cn_hp"; hp.tabIndex = -1; hp.autocomplete = "off";
    hp.setAttribute("aria-hidden", "true");
    hp.style.cssText = "position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0;pointer-events:none";
    form.appendChild(hp);

    /* UN INVIO SOLO. Fra il primo clic e la partenza del modulo nativo
       passano fino a quattro secondi, e in quella finestra un secondo clic
       rientrava qui e mandava una seconda richiesta: due schede nel gestionale
       e due email. La bandierina non si azzera mai apposta — dopo proceed()
       la pagina se ne va, e se la rete fallisce proceed() viene chiamato lo
       stesso, quindi il modulo non resta mai bloccato. */
    var inCorso = false;
    form.addEventListener("submit", function (e) {
      if (form.dataset.cnSent === "1") return;            // secondo giro: lascia partire il nativo

      /* SE QUALCUN ALTRO HA GIA' FERMATO L'INVIO, NOI NON ANDIAMO OLTRE.
         (15 settembre 2026)

         preventDefault() ferma il comportamento predefinito del browser, NON gli
         altri ascoltatori registrati sullo stesso modulo. Il modulo appuntamento
         registra il suo controllo durante il caricamento della pagina — quindi
         prima di noi, che arriviamo con defer — e quando mancano giorno o ora
         chiama preventDefault() e scrive "Scegli il giorno dell'appuntamento.".
         Subito dopo partiva questo ascoltatore, che non guardava niente: mandava
         la richiesta e poi chiamava form.submit(), che salta ogni validazione.
         Risultato: l'utente leggeva l'errore mentre la pagina se ne andava, e nel
         gestionale arrivava un appuntamento senza data.

         defaultPrevented e' il modo standard di chiedere "qualcuno ha gia' detto
         di no?". Sta qui nel ponte e non nel modulo perche' il ponte serve cinque
         moduli: cosi' vale per tutti, anche per quelli che avranno una loro
         validazione domani. */
      if (e.defaultPrevented) return;

      e.preventDefault();
      if (inCorso) return;
      inCorso = true;

      /* IL PULSANTE SI SPEGNE, E SI VEDE CHE E' SPENTO.
         ═══════════════════════════════════════════════
         18 settembre 2026, su segnalazione: «il pulsante risulta cliccabile,
         quando invece non dovrebbe piu' esserlo».

         Sta QUI e non nelle sezioni perche' i moduli sono cinque e il ponte e'
         l'unico punto che sa con certezza quando un invio e' davvero partito:
         piu' su ha gia' lasciato passare chi era stato fermato da un'altra
         validazione (defaultPrevented) e chi e' al secondo giro (cnSent). Se
         si e' arrivati a questa riga, la richiesta parte.

         Non si ripristina niente dopo: da qui si esce solo con proceed(), che
         fa partire il modulo nativo e quindi la pagina. Un ripristino
         riaccenderebbe il pulsante proprio nell'istante in cui la richiesta e'
         gia' in volo, cioe' inviterebbe al secondo invio che stiamo evitando.

         La sezione «vendi il tuo orologio» ha un suo stato piu' ricco (conta le
         fotografie, scrive una riga sotto). Non si pestano i piedi: quella
         scrive DOPO, dagli eventi cn:foto-*, e l'ultimo che scrive vince.
         Qui c'e' solo il minimo che vale per tutti. */
      var bottone = form.querySelector('button[type="submit"], input[type="submit"]');
      if (bottone) {
        bottone.disabled = true;
        if (bottone.tagName === "INPUT") bottone.value = "Invio…";
        else bottone.textContent = "Invio…";
      }

      /* Le fotografie le mette la sezione dentro form._cnFoto: qui non sappiamo
         nulla della sua interfaccia, ci limitiamo a leggerle. */
      var scelte = (form._cnFoto || []).slice(0, FOTO_MAX);

      /* UN IDENTIFICATIVO PER INVIO, uguale di qua e di la'.
         Serve il giorno che la stessa richiesta partira' sia dal browser
         (pixel -> Meta) sia dal server (Worker -> Conversions API): Meta unisce
         i due invii solo se portano lo stesso identificativo, entro 48 ore.
         Costa una riga adesso; senza, il secondo canale non si puo' accendere
         senza contare doppio. Non e' un dato personale: e' un numero casuale. */
      var eid = "cn-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);

      var meta = {
        tipo: typeField.value || "Richiesta",
        pagina: location.pathname,
        inviato_il: new Date().toISOString(),
        secondi_compilazione: Math.round((Date.now() - openedAt) / 1000),
        hp: hp.value || "",
        eid: eid
      };

      /* Quante fotografie sono state scelte e quante sono arrivate davvero.
         La differenza fra i due numeri e' l'unico modo di sapere se il
         caricamento funziona sui telefoni veri, e sulla pagina del grazie
         questi numeri non esistono piu': li porta il biglietto. */
      var fotoScelte = scelte.length, fotoCaricate = 0;

      var done = false, payload = null;

      /* NESSUN ALTRO PUO' PORTARCI VIA LA PAGINA MENTRE CARICHIAMO.
         ═══════════════════════════════════════════════════════════
         Misurato il 17 settembre 2026, con due fotografie vere:

           +30965ms  foto-preparo (2)
           +30991ms  form.submit()          ← 26 ms dopo, non nostro
           +31911ms  PUT foto 1
           +31912ms  PUT foto 2
           +32074ms  la pagina se ne va
           +33133ms  PUT falliti tutti e due, "Failed to fetch"

         Ventisei millisecondi dopo l'inizio qualcuno chiamava form.submit(),
         e la navigazione uccideva i due caricamenti a meta'. Le fotografie non
         arrivavano mai, e il campo «foto» restava giustamente vuoto.

         QUEL DISEGNO NON C'E' PIU' (stesso giorno, poche ore dopo): i PUT sono
         spariti, le fotografie viaggiano dentro la richiesta del modulo. Il
         fermo resta lo stesso, e non e' ridondanza — adesso protegge l'UNICA
         richiesta rimasta, che con sei fotografie puo' durare qualche secondo.
         Prima proteggeva due richieste e una finestra in mezzo: quella finestra
         era il difetto, il fermo era il cerotto. Adesso la finestra non c'e' e
         il fermo e' solo prudenza.

         NON E' CODICE DEL TEMA: qui form.submit() esiste in un posto solo,
         quello qui sotto, e in locale parte una volta sola. In produzione
         partiva due volte, e la prima era di un altro: sul negozio girano
         cinque script di app iniettati da Shopify, e uno e' Globo Form Builder,
         che di mestiere tocca i moduli.

         Invece di inseguire quale sia, il ponte si difende: per tutta la durata
         del suo lavoro SOSTITUISCE form.submit. Chi lo chiama da fuori non fa
         partire la pagina, lascia solo detto che vorrebbe; l'invio vero avviene
         quando abbiamo finito. Se nessuno lo chiede, parte lo stesso da
         proceed() come prima.

         Il ripristino e' il punto delicato: submitVero e' preso PRIMA di
         sostituire, cosi' anche se qualcosa va storto la pagina puo' sempre
         andarsene — e c'e' comunque il timeout di sicurezza piu' sotto. */
      installaFermo();
      if (inAttesa.add) inAttesa.add(form);
      var submitVero = HTMLFormElement.prototype.submit;
      /* DUE PORTE, NON UNA: submit() salta ogni validazione, requestSubmit()
         la rispetta. Le copre tutte e due installaFermo(), sul prototipo. */

      function proceed() {
        if (done) return; done = true;
        /* si toglie il fermo PRIMA di tutto: se qualcosa qui sotto andasse
           storto, la pagina deve comunque poter partire. E si chiama il metodo
           originale del prototipo, non quello sostituito. */
        if (inAttesa.delete) inAttesa.delete(form);
        form.dataset.cnSent = "1";

        /* IL BIGLIETTO PER LA PAGINA DEL GRAZIE.
           Sta QUI perche' questo e' l'ultimo istante utile: di la' il modulo
           non viene nemmeno stampato, quindi secondi di compilazione,
           fotografie e caselle non esistono piu'.
           E' anche la prova che un invio e' avvenuto: snippets/modulo-inviato
           annuncia solo se lo trova, e lo consuma. Cosi' ricaricare la pagina
           del grazie, tornarci col tasto indietro o condividerne l'indirizzo
           non conta una richiesta in piu'.
           sessionStorage e non localStorage: vive quanto la scheda. Dentro non
           c'e' niente di personale — nessun nome, nessun recapito. */
        try {
          var appt = form.querySelector('[name="contact[Appuntamento]"]');
          sessionStorage.setItem("curnis_modulo_ok", JSON.stringify({
            tipo: meta.tipo,
            secondi: meta.secondi_compilazione,
            foto_scelte: fotoScelte,
            foto_caricate: fotoCaricate,
            appuntamento: appt ? (appt.checked ? 1 : 0) : undefined,
            eid: eid,
            t: Date.now()
          }));
        } catch (e) {}

        submitVero.call(form);                            // modulo nativo → email Shopify
      }
      function segnala(nome, dati) {
        try { form.dispatchEvent(new CustomEvent(nome, { detail: dati || {} })); } catch (err) {}
      }

      if (scelte.length) segnala("cn:foto-preparo", { quante: scelte.length });

      /* UNA FOTOGRAFIA CHE NON SI LASCIA RICODIFICARE NON DEVE PORTARSI VIA
         LE ALTRE, NE' IL TESTO. rimpicciolisci ora puo' fallire (e' voluto:
         mandare l'originale significherebbe mandare le coordinate GPS di casa
         del cliente). Qui ogni fotografia si risolve per conto suo, e quelle
         che non ce la fanno diventano null e vengono tolte dall'elenco.
         Le posizioni restano appaiate perche' si filtrano insieme: e' lo
         stesso indice che da' il nome alla fotografia piu' sotto. */
      var pronte = scelte.length
        ? Promise.all(scelte.map(function (f) {
            return rimpicciolisci(f).catch(function () { return null; });
          })).then(function (blob) {
            var tenute = [], buone = [];
            for (var i = 0; i < blob.length; i++) {
              if (blob[i]) { buone.push(blob[i]); tenute.push(scelte[i]); }
            }
            if (tenute.length !== scelte.length) {
              segnala("cn:foto-scartate", { quante: scelte.length - tenute.length });
            }
            scelte = tenute;
            return buone;
          })
        : Promise.resolve([]);

      pronte.then(function (blob) {
        if (!blob.length) return { p: collect(form, meta), quante: 0 };
        segnala("cn:foto-invio", { quante: blob.length });
        return Promise.all(blob.map(inBase64)).then(function (dati) {
          var p = collect(form, meta), foto = [], usati = 0, persi = 0;
          for (var i = 0; i < dati.length; i++) {
            /* lettura fallita, oppure non ci sta piu' nel corpo: si scarta
               QUESTA, non tutta la richiesta */
            if (!dati[i]) { persi++; continue; }
            if (usati + dati[i].length > FOTO_BUDGET) { persi++; continue; }
            usati += dati[i].length;
            foto.push({
              nome: nomeFoto(scelte[i], i),
              tipo: blob[i].type || "image/jpeg",
              dati: dati[i]
            });
          }
          if (persi) segnala("cn:foto-scartate", { quante: persi });
          if (foto.length) p.foto = foto;
          return { p: p, quante: foto.length };
        });
      }).then(function (r) {
        payload = r.p;
        /* UNA SOLA ANDATA. Qui dentro c'e' tutto: il testo e le fotografie.
           Quando questa risposta torna, non resta niente da fare — ed e'
           esattamente il motivo per cui adesso arrivano. */
        return post(payload, r.quante ? TIMEOUT_FOTO : TIMEOUT_MS).then(function (d) {
          if (!r.quante) return;
          /* il Worker dice quante ne ha messe davvero nel secchio */
          var messe = d && typeof d.foto === "number" ? d.foto : r.quante;
          fotoCaricate = messe;                             // serve al biglietto, in proceed()
          segnala("cn:foto-fine", { caricate: messe, totale: r.quante });
        });
      }).then(proceed).catch(function () {
        if (payload && !paginaSeNeVa) {
          /* Ci si arriva solo se la pagina e' ancora qui: se se ne stesse
             andando, la richiesta e' probabilmente arrivata lo stesso e
             rimetterla in coda farebbe una scheda doppia.

             In coda non rimettiamo le fotografie, e adesso per un motivo
             diverso da prima: non sono i recapiti a scadere — e' che la coda sta
             in localStorage, che tiene cinque megabyte in tutto. Sei fotografie
             lo riempirebbero da sole e farebbero sparire anche le richieste di
             testo gia' in attesa. Si salva il testo, che e' la parte che conta,
             e le fotografie si richiedono per email. */
          var p = collect(form, meta);
          var q = readQueue(); q.push(p); writeQueue(q);
        }
        proceed();
      });

      /* Non blocchiamo mai l'utente. Con le fotografie serve piu' respiro:
         andarsene a meta' caricamento le perderebbe tutte. */
      setTimeout(proceed, scelte.length ? TIMEOUT_FOTO + 5000 : TIMEOUT_MS + 300);
    });
  }

  /* nome pulito e riconoscibile, senza rivelare il nome originale del file */
  function nomeFoto(file, i) {
    var t = (file && file.type) || "";
    var est = t.indexOf("png") > -1 ? "png" : (t.indexOf("webp") > -1 ? "webp" : "jpg");
    return "foto-" + (i + 1) + "." + est;
  }

  /* Quello che la sezione puo' chiedere al ponte. I limiti stanno scritti in un
     posto solo, e «prepara» e' la porta per far cominciare presto il lavoro:
     la sezione la chiama appena l'utente sceglie una fotografia, e il risultato
     finisce nella cache qui sopra. Al momento dell'invio e' gia' fatto.

     Restituisce una promessa che non fallisce mai: se la ricodifica non riesce
     torna il file originale, come sempre — una fotografia non si perde. */
  window.CurnisFoto = {
    max: FOTO_MAX,
    pesoMax: FOTO_PESO_MAX,
    lato: FOTO_LATO,
    prepara: function (file) { return rimpicciolisci(file); }
  };

  /* LA PAGINA DELLA VERIFICA «NON SONO UN ROBOT» NON VA AGGANCIATA.
     ═══════════════════════════════════════════════════════════════
     Questo ha prodotto richieste DOPPIE nel gestionale, e per capirlo
     e' servito guardare la colonna «pagina»: ogni coppia aveva un
     /pages/contatti e un /it/challenge a mezzo minuto di distanza.

     Il perche'. Quando Shopify sospetta spam non accetta l'invio: apre
     /challenge e li' rimette il modulo originale, con tutti i campi
     contact[...] dentro come campi nascosti, per poterlo rigiocare
     appena la verifica e' superata. Quel modulo punta a /contact esatta-
     mente come quello vero — quindi il ponte lo scambiava per un modulo
     nuovo, lo agganciava, e al secondo invio mandava al Worker una
     SECONDA richiesta identica. Una per la compilazione, una per la
     verifica.

     Due guardie invece di una, perche' proteggono da cose diverse:
     la prima guarda l'indirizzo (e regge i prefissi di lingua, /it/ e
     compagnia), la seconda guarda se dentro il modulo c'e' un riquadro
     di verifica — e quella regge anche il giorno in cui Shopify decide
     di mostrare la verifica su un indirizzo diverso. */
  function paginaDiVerifica() {
    return /(^|\/)challenge(\/|$)/.test(location.pathname);
  }

  function moduloDiVerifica(form) {
    return !!form.querySelector(
      '.g-recaptcha, [data-recaptcha], [name="g-recaptcha-response"], .h-captcha, [name="h-captcha-response"]'
    );
  }

  function init() {
    /* PRIMA DI TUTTO IL RESTO. Va messo prima che Shopify carichi hCaptcha,
       che si fotografa prototype.submit quando parte: vedi il commento lungo
       sopra installaFermo. Non trattiene niente finche' non c'e' un modulo
       davvero in volo — installarlo presto non cambia nessun comportamento,
       cambia solo chi lo vede. */
    installaFermo();

    /* flushQueue resta fuori dalla guardia: la coda va svuotata comunque,
       anzi la pagina della verifica e' un buon momento per farlo. */
    if (!paginaDiVerifica()) {
      var forms = document.querySelectorAll('form[action*="/contact"]');
      for (var i = 0; i < forms.length; i++) bridge(forms[i]);
    }
    flushQueue();
  }

  /* Il fermo non aspetta nemmeno DOMContentLoaded: non gli serve il documento,
     gli serve solo di arrivare prima di hCaptcha. */
  installaFermo();

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
